module.exports = __webpack_public_path__ + "static/media/chat08.bb3031c4.gif";